import type { TOC } from '@ember/component/template-only';

const DatamanagerRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default DatamanagerRouteTemplate;
